import CheckboxTable from './CheckboxTable';

export default CheckboxTable;
